// extracted by mini-css-extract-plugin
module.exports = {"mega-menu-navigation-category":"l2-navigation_mega-menu-navigation-category__QcWAD"};